import { render, staticRenderFns } from "./Writer.vue?vue&type=template&id=139ddc0a"
import script from "./Writer.vue?vue&type=script&lang=js"
export * from "./Writer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports